import React from "react";
import {
  makeStyles,
  Typography,
  Popover,
  Box,
  MenuItem,
  MenuList,
} from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  button: {
    padding: 0,
    minWidth: 0
  },
  perfectScrollBar: {
    maxHeight: 200,
    overflow: "auto"
  },
  list: {
    paddingTop: 6,
    paddingBottom: 6
  }
}));

function ProductLanguageSelectPanelComponent({
  open,
  anchorEl,
  handleClose,
  handleClick,
  id,
  style,
  options,
  anchorOrigin,
  transformOrigin,
  PaperProps,
}) {
  const classes = useStyle();

  // Get display name for the language
  const getDisplayLanguage = (langCode) => {
    if (!langCode) return '';

    // Map of language codes to display names
    const languageDisplayNames = {
      "EN": "English",
      "ZH": "简体中文",
      "ZH-CN": "简体中文",
      "ZH-TW": "繁體中文",
      "ZHTW": "繁體中文",
      "VI": "Tiếng Việt",
      "TH": "ไทย",
      "MS": "Bahasa Melayu",
      "MS-MY": "Bahasa Melayu",
      "ID": "Bahasa Indonesia",
      "TL": "Tagalog (Filipino)"
    };

    // Try to find the language display name, case-insensitive
    const upperLangCode = langCode.toUpperCase();
    for (const [code, name] of Object.entries(languageDisplayNames)) {
      if (code.toUpperCase() === upperLangCode) {
        return name;
      }
    }

    return langCode;
  };

  return (
    <Popover
      id={id}
      open={open}
      style={style}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      elevation={2}
      PaperProps={PaperProps}
    >
      <Box className={classes.perfectScrollBar}>
        <Box>
          <MenuList
            id='menu-list-grow'
            className={classes.list}
          >
            {options.map((option, index) => (
              <MenuItem
                key={index}
                onClick={() => handleClick(option)}
              >
                <Box display="flex" alignItems="center">
                  <Typography variant='body1' noWrap style={{ paddingLeft: 8, paddingRight: 8 }}>
                    {getDisplayLanguage(option)}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
          </MenuList>
        </Box>
      </Box>
    </Popover>
  );
}

export default ProductLanguageSelectPanelComponent;
